export const cmdId = 'edit-script' as const;